/**
 * The words shown for a tenant role. Legacy stored names (admin, editor,
 * viewer) read the same as the current ones. Used by Members (Users and
 * Groups) so both sections name a role the same way.
 */
export function roleLabel(role: string): string {
  switch (role) {
    case "tenant_admin": case "admin": return "Tenant admin";
    case "agent_admin": case "editor": return "Agent admin";
    case "standard_user": case "viewer": return "Standard user";
    default: return role;
  }
}
